export default "__VITE_ASSET__bb31bi9___"